<template>
  <div
    v-if="!chosen || (chosen && chosen.length === 0)"
    class="cpt-search-input bg-op-s2 rounded-[5px] px-[12px] w-full h-[36px] flex-items-center cursor-text relative"
    :class="[size, {'highlight': highlight && focusing, 'has-error': errorText}]"
    @click.stop="$refs['input'].focus()"
  >
    <i v-if="icon" class="iconfont icon" :class="icon" :style="{color: value ? 'var(--text-2)' : ''}"></i>
    <input
      ref="input"
      :type="isPassword ? 'password' : 'text'"
      :class="{ 
        password: isPassword,
        'input-emoji': showEmoji 
      }"
      :placeholder="placeholder" 
      @input="handleInput" 
      :value="value" 
      autocomplete="off" 
      disableautocomplete
      :disabled="disabled"
      @keyup.enter="handleEnter" 
      @compositionstart="enterLock=true"
      @compositionend="handleEnd"
      @focus="handleFocus"
      @blur="handleBlur"
      :readOnly="readOnly"
      @keyup="handleLimitLength"
      @keydown="handleKeydown"
    />
    <i
      v-if="clearable && value"
      class="iconfont icon-close-bold"
      @click="clear"
    ></i>
    <div
      class="icon-emoji-wrapper flex-center absolute right-[6px] top-1/2 -translate-y-1/2 w-[28px] h-[28px] pointer rounded-[3px]"
      :class="{'bg-op-2': showEmojiContainer}"
      v-if="showEmoji"
    >
      <i
        class="iconfont icon-emoji"
        @click.stop="handleShowEmoji"
      ></i>
    </div>
    <div class="absolute top-[calc(100%+4px)] left-0 text-[12px] leading-[16px] text-er-tx" v-if="errorText">{{ errorText }}</div>
    <slot></slot>
  </div>
  <div class="cpt-search-input search-muti" v-else>
    <TabBlock 
      :title="item.title || item.name" 
      v-for="(item, i) in chosen" 
      :key="i" 
      imgType="rectangle"
      :img="item.img" 
      :closeable="!hideChosenRemove"
      @close="$emit('removeChose', item, i)"
    ></TabBlock>
    <input 
      ref="input"
      type="text"
      @input="handleInput" 
      :value="value" 
      autocomplete="off" 
      disableautocomplete
      :disabled="disabled"
      @keyup.enter="handleEnter" 
      @compositionstart="enterLock=true"
      @compositionend="handleEnd"
      @focus="handleFocus"
      @blur="handleBlur"
      :readOnly="readOnly"
      @keyup="handleLimitLength"
      @keydown="handleKeydown"
    />
  </div>
</template>

<script>
import TabBlock from '_com/form/TabBlock.vue';
import EventBus from '@/common/EventBus'

export default {
  name: "Input",
  props: {
    value: {
      type: String || Number,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    icon: {
      default: "",
      type: String,
    },
    size: {
      default: "small",
      type: String,
    },
    clearable: {
      default: false,
      type: Boolean
    },
    isPassword: {
      default: false,
      type: Boolean
    },
    reg: {
      default: ''
    },
    chosen: {
      default: null,
      type: Array,
    },
    hideChosenRemove: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    readOnly: {
      default: false,
      type: Boolean
    },
    maxLength: {
      default: 9999,
      type: Number
    },
    showEmoji: {
      default: false,
      type: Boolean
    },
    highlight: {
      default: false,
      type: Boolean
    },
    errorText: {
      default: '',
      type: String
    },
  },
  components: {
    TabBlock
  },
  data() {
    return {
      enterLock: false,
      focusing: false,
      showEmojiContainer: false
    }
  },
  watch: {
    enterLock(v) {
      this.$emit('enter-lock-change', v)
    }
  },
  beforeDestroy() {
    EventBus.$off('Hide_Emoji_Selector', this.onHideEmoji)
    this.$emit('beforeDestroy')
  },
  methods: {
    focus () {
      this.$refs['input'].focus()
    },
    clear () {
      this.$emit('input', '')
    },
    handleInput(e) {
      if (this.enterLock) return
      let v = e.target.value;
      if (this.reg) {
        v = v.replace(this.reg, '')
        e.target.value = v
      }
      this.$emit("input", v);
    },
    handleEnd() {
      this.enterLock = false
    },
    handleEnter() {
      if (this.enterLock) return
      this.$emit('enter', this.value)
    },
    handleFocus() {
      this.focusing = true
      this.$emit('focus')
    },
    handleBlur() {
      this.focusing = false
      this.$emit('blur')
    },
    handleLimitLength(e) {
      this.$emit('keyup', e)
      if(this.enterLock) return
      const input = e.target;
      const value = input.value;

      const getStringLength = (str) => {
        const codePoints = Array.from(str);
        let totalLength = 0;
        
        for (let char of codePoints) {
          const codePoint = char.codePointAt(0);
          
          if (codePoint <= 127) {
            // ASCII
            totalLength += 1;
          } else if (codePoint >= 0x4E00 && codePoint <= 0x9FFF) {
            // 汉字
            totalLength += 2;
          } else {
            // 其他字符
            totalLength += 1;
          }
        }
        return totalLength;
      };

      const currentLength = getStringLength(value);
      const maxLength = this.maxLength;

      if (currentLength > maxLength) {
        let truncatedValue = '';
        let currentTotalLength = 0;
        
        for (let char of Array.from(value)) {
          const charLength = getStringLength(char);
          
          if (currentTotalLength + charLength <= maxLength) {
            truncatedValue += char;
            currentTotalLength += charLength;
          } else {
            break;
          }
        }
        
        input.value = truncatedValue;
        this.$toast.error("当前字数已达上限");
      }
      input.dispatchEvent(new Event('input'))
    },
    handleKeydown(e) {
      this.$emit('keydown', e)
    },
    handleShowEmoji(e) {
      if (this.showEmojiContainer) {
        this.showEmojiContainer = false
        EventBus.$emit('Show_Emoji_Selector', false)
        return
      }
      this.showEmojiContainer = true
      EventBus.$on('Hide_Emoji_Selector', this.onHideEmoji)
      let pos = e.target.getBoundingClientRect()
      pos.x += 200
      EventBus.$emit('Show_Emoji_Selector', true, pos, `InputEmoji`, this.chooseEmoji)
    },
    onHideEmoji() {
      this.showEmojiContainer = false
      EventBus.$off('Hide_Emoji_Selector', this.onHideEmoji)
    },
    chooseEmoji(group_type, item, size) {
      // src: 最近使用表情， url: 盒娘大表情， 拼接: cube小标签和盒娘中表情
      let img_info = {
        ...item,
        group_type,
        size
      }
      this.cursorPosition = this.$refs.input.selectionStart;
      const text = img_info.icon
      const newValue = this.value.slice(0, this.cursorPosition) + text + this.value.slice(this.cursorPosition);
      
      this.handleInput({target: {value: newValue}})

      // 更新光标位置，光标位置应该在插入的文字之后
      this.cursorPosition += text.length;
      this.$nextTick(() => {
        this.focus()
        this.$refs.input.selectionStart = this.cursorPosition;
        this.$refs.input.selectionEnd = this.cursorPosition;
      })
      EventBus.$emit('Show_Emoji_Selector', false)
    }
  },
};
</script>

<style lang="scss">
.cpt-search-input {
  &.highlight {
    outline: 1px solid $d-bd-tx;
  }
  &.search-muti {
    flex-wrap: wrap;
    height: auto !important;
    min-height: 42px;
    padding: 6px 0 0 6px;
    input {
      margin-right: 6px;
      margin-bottom: 6px;
      min-width: 30%;
    }
  }
  &.big {
    height: 42px;
    .iconfont {
      width: 16px;
      height: 16px;
      font-size: 16px;
      &.icon {
        margin-right: 6px;
      }
    }
    input {
      height: 100%;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
    }
  }
  &.has-error {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 1px solid $d-er-tx;
      border-radius: inherit;
    }
  }
  .input-emoji {
    margin-right: 28px;
  }
  .iconfont {
    width: 12px;
    height: 12px;
    font-size: 12px;
    color: $d-tx-3;
    cursor: pointer;
    &.icon {
      color: $d-op-3;
      margin-right: 3px;
    }
    &.icon-emoji {
      width: 20px;
      height: 20px;
      font-size: 20px;
    }
  }
  input {
    width: 0;
    flex: 1;
    height: 100%;
    background: transparent;
    color: $d-tx-2;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    display: block;
    &::-webkit-input-placeholder {
      font-style: normal;
      color: $d-op-3;
    }
  }
  .cpt-tab-block {
    margin-right: 6px;
    margin-bottom: 6px;
  }
}
</style>
